type Listener = () => void;

// 遷移先が元のURLへリダイレクトされるとURLが変わらず完了を検知できないため、一定時間で打ち切る
export const NAVIGATION_PROGRESS_TIMEOUT_MS = 10_000;

const listeners = new Set<Listener>();
let activeTaskCount = 0;
let navigationTimer: ReturnType<typeof setTimeout> | null = null;

const emit = () => {
  for (const listener of listeners) listener();
};

export const subscribeTopProgress = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const isTopProgressActive = (): boolean => activeTaskCount > 0 || navigationTimer !== null;

export const startTopProgress = (): (() => void) => {
  activeTaskCount += 1;
  emit();
  let isStopped = false;
  return () => {
    if (isStopped) return;
    isStopped = true;
    activeTaskCount -= 1;
    emit();
  };
};

export const startNavigationProgress = (): void => {
  if (navigationTimer) clearTimeout(navigationTimer);
  navigationTimer = setTimeout(completeNavigationProgress, NAVIGATION_PROGRESS_TIMEOUT_MS);
  emit();
};

export const completeNavigationProgress = (): void => {
  if (!navigationTimer) return;
  clearTimeout(navigationTimer);
  navigationTimer = null;
  emit();
};

export const isNavigationToAnotherPage = (href: string, currentUrl: URL): boolean => {
  const nextUrl = new URL(href, currentUrl);
  return nextUrl.origin !== currentUrl.origin || nextUrl.pathname !== currentUrl.pathname || nextUrl.search !== currentUrl.search;
};
